export default __webpack_public_path__ + "static/commmune_communitymarketing_report_02_2023_WP-274d0eeb45f51c5eb7d21f2ab3d8a9cf.png";